export default __webpack_public_path__ + "static/media/bd.4fc8456c.svg";